const emailActionTypes = {
    SET_SHARE_ANALYTICS_LOADING: "SET_SHARE_ANALYTICS_LOADING",
    SET_SHARE_ANALYTICS_OPEN: "SET_SHARE_ANALYTICS_OPEN",
};

export default emailActionTypes;
